import EquipmentPassportVersionsHistorySidePage from '@/pages/Equipment/components/SidePages/EquipmentPassportVersionsHistorySidePage'
import Button from '@/shared/Buttons/Button'
import { useState } from 'react'
import VersionHistoryIcon from '@/assets/icons/version-history.svg?react'
import { IEquipment } from '@/pages/Equipment/equipment.types'

interface IProps {
  equipment: IEquipment
}

const PassportVersionHistoryButton = (props: IProps) => {
  const [versionHistoryOpen, setVersionHistoryOpen] = useState(false)
  return (
    <>
      <Button
        size="default"
        type="tetriary"
        text="История версий"
        icon={<VersionHistoryIcon />}
        onClick={() => {
          setVersionHistoryOpen(true)
        }}
      />
      <EquipmentPassportVersionsHistorySidePage
        onCancel={() => setVersionHistoryOpen(false)}
        open={versionHistoryOpen}
        equipment={props.equipment}
      />
    </>
  )
}

export default PassportVersionHistoryButton
